export class AuthenticationToken {
    constructor(public email: string, public bearerToken: string, public refreshToken: string) {
    }
}
